<template>
  <Layout>
    <DashboardHeader slot="header">
      <FavouriteLogosButton
        text="Favorites"
        class="ml-6"
        @click="favouritesOpen = true"
      />
    </DashboardHeader>

    <FavouriteLogos
      :favouritesOpen="favouritesOpen"
      @onOpen="favouritesOpen = true"
      @onClose="favouritesOpen = false"
    />

    <nuxt v-if="authed" />
  </Layout>
</template>

<script>
import DashboardHeader from '@/components/dashboard/DashboardHeader'
import FavouriteLogosButton from '@/components/favourites/FavouriteLogosButton'
import FavouriteLogos from '@/components/favourites/FavouriteLogos'
import { EventBus, Events } from '@/lib/events'
import Layout from '@/components/Layout'
import Dim from '@/components/Dim'
import { mapActions } from 'vuex'

export default {
  components: {
    DashboardHeader,
    FavouriteLogosButton,
    FavouriteLogos,
    Layout,
    Dim,
  },

  data: () => ({
    favouritesOpen: false,
    authed: false,
  }),

  mounted() {
    EventBus.$on(Events.EditorSelectLogo, this.goToLogo)

    this.$getAuthInstance().then(auth =>
      auth
        .currentAuthenticatedUser()
        .then(() => (this.authed = true))
        .catch(() => this.$router.push('/login'))
    )
  },

  beforeDestroy() {
    EventBus.$off(Events.EditorSelectLogo, this.goToLogo)
  },

  methods: {
    ...mapActions({ markStepAsComplete: 'dashboard/markStepAsComplete' }),

    goToLogo(logo) {
      if (logo) {
        this.$router.push({ path: '/editor', query: { logo: logo.id } })
      }
    },
  },
}
</script>
